import { render, staticRenderFns } from "./bookloan.vue?vue&type=template&id=46b72f6a&scoped=true&"
import script from "./bookloan.vue?vue&type=script&lang=js&"
export * from "./bookloan.vue?vue&type=script&lang=js&"
import style0 from "./bookloan.vue?vue&type=style&index=0&id=46b72f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b72f6a",
  null
  
)

export default component.exports